import { defineStore } from 'pinia'
import { IStore } from '@/system-modules/win-manager/v1/core/interface/IStore'

export default defineStore('systemWinManagerStoreV1', {
  state: (): IStore => {
    return {
      windows: {},
      moduleId: '',
    }
  },
})
